
import SkillItem from './skill-item.vue'
import {MAX_TEST_SKILLS} from './test-skills-defs'

export default {
  components: {SkillItem},
  props: {
    skills: {type: Array, required: true},
    selectedIdx: {type: Number, default: undefined},
    saving: {type: Boolean, default: false},
    saved_at: {type: Number, default: undefined}
  },
  emits: ['edit', 'delete'],
  data() {
    return {
      max_skills: MAX_TEST_SKILLS
    }
  },
  computed:{
    description() {
      return this.skills.length >= this.max_skills ? 'Skill limit reached. Delete a skill to add another.' : 'Review, edit, or delete your test skills'
    },
    title(){
      return `Saved skills (${ this.skills.length }/${ this.max_skills })`
    }
  }
}
